import { useEffect, useRef, useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import classApi from "../../api/class/class";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import { ui } from "../../helpers/ui";

const InitClassLogic = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<any[]>([]);
  const trainingTypeRef = useRef<any>();
  const [data, setData] = useState<any>({
    client: "",
    trainingType: "",
  });
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClients, setSelectedClients] = useState<any[]>([]);

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
          if (response.data.length > 0) {
            setData((prev: any) => ({
              ...prev,
              trainingType: response.data[0].id.toString(),
            }));
          }
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data.filter((c: any) => !c.disabled));
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onSave = async () => {
    if (!trainingTypeRef.current?.value) {
      ui.alert("Izaberite tip treninga");
      return;
    }
    if (selectedClients.length === 0) {
      ui.alert("Izaberite bar jednog klijenta");
      return;
    }
    const confirmed = await ui.confirm("Sigurno želite da sačuvate ovaj trening?");
    if (!confirmed) return;
    classApi
      .saveClass({
        trainingType: trainingTypeRef.current.value,
        clients: selectedClients,
      })
      .then(async (response) => {
        if (response.status === 204) {
          ui.toast("Trening sačuvan", "success");
          navigate("/home");
        } else if (response.status === 200 && response.data?.warning) {
          ui.alert(response.data.warning);
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const addClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza i bez duplikata
    if (selectedClients.some((c: any) => c.id === client.id)) return;
    setClients(clients.filter((c: any) => c.id !== client.id));
    setSelectedClients([...selectedClients, client]);
    setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    if (!selectedClients.some((c: any) => c.id === client.id)) return;
    setSelectedClients(selectedClients.filter((c: any) => c.id !== client.id));
    setClients([...clients, client]);
  };

  useEffect(() => {
    loadCategories();
    loadClients();
  }, []);

  return {
    selectedClients,
    clients,
    data,
    trainingTypeRef,
    categories,
    onSave,
    onChange,
    addClient,
    removeSelectedClient,
  };
};

export default InitClassLogic;
